/* eslint-disable react/prop-types */
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import HeaderPDF from './HeaderPDF';
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    color: '#2c3e50',
  },
  section: {
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 5,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#34495e',
    borderBottom: '1px solid #bdc3c7',
    paddingBottom: 5,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  column: {
    flex: 1,
    marginRight: 10,
  },
  label: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#7f8c8d',
    marginBottom: 2,
  },
  value: {
    fontSize: 10,
    color: '#2c3e50',
    marginBottom: 8,
  },
  checkboxContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 5,
  },
  checkboxItem: {
    flexDirection: 'row',
    marginRight: 15,
    marginBottom: 3,
    alignItems: 'center',
  },
  checkbox: {
    width: 8,
    height: 8,
    border: '1px solid #34495e',
    marginRight: 5,
    backgroundColor: '#ffffff',
  },
  checkedBox: {
    width: 8,
    height: 8,
    border: '1px solid #34495e',
    marginRight: 5,
    backgroundColor: '#27ae60',
  },
  checkboxText: {
    fontSize: 9,
    color: '#2c3e50',
  },
  footer: {
    marginTop: 20,
    padding: 10,
    borderTop: '1px solid #bdc3c7',
    fontSize: 8,
    color: '#7f8c8d',
    textAlign: 'center',
  }
});

const ExportPDFApplicationExternalForm = ({ user, data,agencyInfo }) => {


  // Helper function to render checkbox items
  const renderCheckboxItems = (items, selectedItems = []) => {
    return items.map((item, index) => (
      <View key={index} style={styles.checkboxItem}>
        <View style={selectedItems.includes(item) ? styles.checkedBox : styles.checkbox} />
        <Text style={styles.checkboxText}>{item}</Text>
      </View>
    ));
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
       <HeaderPDF user={user} agencyInfo={agencyInfo} />
        <Text style={styles.title}>Application External Form</Text>
        
        {/* Marital Status */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Marital Status</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Marital Status:</Text>
              <Text style={styles.value}>{data.maritalStatus || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.checkboxContainer}>
            <View style={data.marriageRegistered ? styles.checkedBox : styles.checkbox} />
            <Text style={styles.checkboxText}>Marriage Registered</Text>
          </View>
        </View>

        {/* Employer Information */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Employer Information</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Employer Name:</Text>
              <Text style={styles.value}>{data.employerName || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Date of Birth:</Text>
              <Text style={styles.value}>{data.employerDob || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>NRIC:</Text>
              <Text style={styles.value}>{data.employerNric || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Passport:</Text>
              <Text style={styles.value}>{data.employerPassport || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Profession:</Text>
              <Text style={styles.value}>{data.profession || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Company:</Text>
              <Text style={styles.value}>{data.company || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Contact Information */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Contact Information</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Office Phone:</Text>
              <Text style={styles.value}>{data.officePhone || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Mobile Phone:</Text>
              <Text style={styles.value}>{data.mobilePhone || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Home Phone:</Text>
              <Text style={styles.value}>{data.homePhone || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Email:</Text>
              <Text style={styles.value}>{data.email || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Address:</Text>
              <Text style={styles.value}>{data.address || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Type of Dwelling */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Type of Dwelling</Text>
          <View style={styles.checkboxContainer}>
            {renderCheckboxItems(
              ['HDB Flat', 'Condominium', 'Landed Property', 'Others'],
              data.dwelling || []
            )}
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Levels:</Text>
              <Text style={styles.value}>{data.levels || '1'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Bedrooms:</Text>
              <Text style={styles.value}>{data.bedrooms || '3'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Toilets:</Text>
              <Text style={styles.value}>{data.toilets || '0'}</Text>
            </View>
          </View>
        </View>

        {/* Residential Status */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Residential Status</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Residential Status:</Text>
              <Text style={styles.value}>{data.resStatus || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Family Members */}
        {data.familyMembers && data.familyMembers.length > 0 && (
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Family Members</Text>
            {data.familyMembers.map((member, index) => (
              <View key={index} style={styles.row}>
                <View style={styles.column}>
                  <Text style={styles.label}>Name:</Text>
                  <Text style={styles.value}>{member.name || 'Not specified'}</Text>
                </View>
                <View style={styles.column}>
                  <Text style={styles.label}>Age:</Text>
                  <Text style={styles.value}>{member.age || 'Not specified'}</Text>
                </View>
                <View style={styles.column}>
                  <Text style={styles.label}>Relationship:</Text>
                  <Text style={styles.value}>{member.relationship || 'Not specified'}</Text>
                </View>
              </View>
            ))}
          </View>
        )}

        {/* Footer */}
        <View style={styles.footer}>
          <Text>Application External Form Generated on {new Date().toLocaleDateString()}</Text>
          {user && (
            <Text>Agency: {user.company?.name || 'Not specified'}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};

export default ExportPDFApplicationExternalForm;
